import createNsPathsObject from './utils/createNsPathsObject';

export const i18translation = createNsPathsObject('translation');
